module.exports = __webpack_public_path__ + "img/card4.aa8d4808.jpg";